// Generated by CoffeeScript 1.11.1
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('sp/ui/questions/question_forms/scoring',['require','../question_form','../../check_radio'],function(require) {
  var CheckRadio, QuestionForm, Scoring;
  QuestionForm = require('../question_form');
  CheckRadio = require("../../check_radio");
  return Scoring = (function(superClass) {
    extend(Scoring, superClass);

    function Scoring() {
      this.scoringResetButtonClickHandler = bind(this.scoringResetButtonClickHandler, this);
      this.radioChangeHandler = bind(this.radioChangeHandler, this);
      return Scoring.__super__.constructor.apply(this, arguments);
    }

    Scoring.prototype.tagName = "form";

    Scoring.prototype.events = {
      "click .scoring-reset-btn": "scoringResetButtonClickHandler"
    };

    Scoring.prototype.initialize = function(options) {
      return Scoring.__super__.initialize.call(this, options);
    };

    Scoring.prototype.render = function() {
      var $labels, $resetBtn, $table, $tbody, $tfoot, $th, $thead, $tr, maxLabel, minLabel;
      Scoring.__super__.render.call(this);
      $table = $("<table>").prependTo(this.el);
      $thead = $("<thead>").appendTo($table);
      $tr = $("<tr>").append($("<th>").html("&nbsp;")).prependTo($thead);
      minLabel = this.model.get('properties').minLabel;
      maxLabel = this.model.get('properties').maxLabel;
      _.each(this.model.get("properties").values, (function(_this) {
        return function(value, cellIndex) {
          var $th;
          return $th = $("<th>").text(value).appendTo($tr);
        };
      })(this));
      if ((minLabel && minLabel.length) || (maxLabel && maxLabel.length)) {
        $labels = $('<tr>').addClass('score-labels').append($("<th>").html("&nbsp;")).prependTo($thead);
        $th = $("<th>").attr({
          colspan: this.model.get("properties").values.length
        }).appendTo($labels);
        if (minLabel && minLabel.length) {
          $('<div>').addClass('score-label score-label-min').text(minLabel).appendTo($th);
        }
        if (maxLabel && maxLabel.length) {
          $('<div>').addClass('score-label score-label-max').text(maxLabel).appendTo($th);
        }
      }
      $tfoot = $("<tfoot>").appendTo($table);
      $resetBtn = $('<a>').attr({
        href: "#"
      }).addClass('scoring-reset-btn').text('reset');
      $tr = $("<tr>").prependTo($tfoot);
      $("<td>").attr({
        colspan: this.model.get("properties").values.length
      }).html("&nbsp;").appendTo($tr);
      $("<td>").append($resetBtn).appendTo($tr);
      $tbody = $("<tbody>").appendTo($table);
      _.each(this.model.get("properties").labels, (function(_this) {
        return function(label, rowIndex) {
          $tr = $("<tr>").appendTo($tbody);
          $("<td>").addClass("label").text(label).appendTo($tr);
          return _.each(_this.model.get("properties").values, function(value, cellIndex) {
            var $input, id;
            id = (_this.model.get("_id")) + "[" + rowIndex + "][" + cellIndex + "]";
            $input = new CheckRadio("radio", null, {
              name: label,
              id: id,
              value: value
            }).render();
            $input.change(_this.radioChangeHandler);
            return $("<td>").append($input).appendTo($tr);
          });
        };
      })(this));
      return this.el;
    };

    Scoring.prototype.radioChangeHandler = function(e) {
      this.values = [];
      this.$el.find('input:checked').each((function(_this) {
        return function(index, item) {
          var $item;
          $item = $(item);
          return _this.values.push({
            label: $item.closest('tr').find('td.label').text(),
            value: $item.val()
          });
        };
      })(this));
      return this.trigger(QuestionForm.UPDATE_EVENT, this);
    };

    Scoring.prototype.setValues = function(vals) {
      if (_.isArray(vals)) {
        vals.forEach((function(_this) {
          return function(val, index) {
            return _this.$el.find("td.label:contains(" + (JSON.stringify(val.label)) + ")").siblings().each(function(index, item) {
              var $item;
              $item = $(item).find('input');
              return $item.prop('checked', $item.val() === val.value);
            });
          };
        })(this));
        return this.$el.find('input').last().trigger('change');
      }
    };

    Scoring.prototype.scoringResetButtonClickHandler = function(e) {
      e.preventDefault();
      $('input[type=radio]').attr('checked', false);
      this.values = [];
      return this.trigger(QuestionForm.UPDATE_EVENT, this);
    };

    return Scoring;

  })(QuestionForm);
});

